<template>
    <a :href="'mailto:' + value" v-html="value"></a>
</template>

<script>
    export default {
        name: 'VEmail',

        props: {
            value: {
                type: String,
                required: true,
            },
        },
    }
</script>